import store from 'dashboard/store';

import EncounterInterface from 'dashboard/templates/views/Encounter/EncounterInterface';

import vitalSigns from './vital-signs';
import walkingTest from './walking-test';
import clinicalAssessment from './clinical-assessment';
import medicationDSS from './medication-dss';

/**
 * Encounter routes
 * @name router.Encounter
 */

export default {
  path: 'encounter/:version',
  component: EncounterInterface,
  redirect: { name: 'PatientEncounterVitalSigns' },
  props: true,
  meta: {
    title: 'Encounter',
  },
  children: [
    vitalSigns,
    walkingTest,
    clinicalAssessment,
    medicationDSS,
  ],
  async beforeEnter(to, from, next) {
    const { patientId, version } = to.params;

    if (!version || version < 1 || version > 7)  {
      next({ name: 'PatientOverview', params: { patientId } });
    }

    await store.dispatch('encounter/init', { patientId, version });
    // await store.dispatch('medicalHistory/get');

    if (store.getters['encounter/version']) next();
  }
};

